import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';

const newUserSchema = {
  email: {
    type: String,
    required: true,
    validate: {
      message: 'loginSchema.invalid-email',
      validator: value => isEmail(value),
    },
  },
  role: {
    type: String,
    required: true,
    validate: {
      message: 'common.choose-role',
      validator: value => !isEmpty(value) && value !== 'common.choose-role',
    },
  },
};

export default newUserSchema;



// WEBPACK FOOTER //
// ./src/schemas/newUser.js